"use strict";

var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _apolloClient = require("@/apollo/apolloClient");
var _recruitmentQuery = require("@/apollo/queries/recruitment-query");
var _recruitmentMutation = require("@/apollo/mutations/recruitment-mutation");
var _auth = require("@/utils/auth");
var _timeUtil = require("@/utils/time-util");
var _appUtil = require("@/utils/app-util");
var _v = _interopRequireDefault(require("uuid/v4"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      delete_id: '',
      biography_btn: '略歴書の登録',
      form: [{
        id: '',
        // ID
        client_uuid: '',
        // クライアントUUID
        store_name: '',
        // 店名
        contact_name: '',
        // 担当者名
        phone_number: '',
        // 電話番号
        mail_address: '',
        // メールアドレス
        occupation: '',
        // 職種
        site_address: '',
        // 現場住所
        start_period_date: '',
        // 期間（開始）
        end_period_date: '',
        // 期間（終了）
        shift: '',
        // シフト内容
        staff_count: '',
        // 募集人数
        working_hours: '',
        // 勤務時間
        holiday: '',
        // 休日
        reception: '',
        // 待遇
        reason: '',
        // 募集理由
        workplace_composition: '',
        // 職場構成
        prerequisite_type: '',
        // 働く上での必須条件（性格）
        prerequisite_spec: '',
        // 働く上での必須条件（資格）
        condition_type: '',
        // 働く上でのでlきれば必要な条件（性格）
        condition_spec: '',
        // 働く上でのでlきれば必要な条件（資格）
        job_description: '',
        // 仕事内容
        is_active: false,
        // 公開フラグ（true = 公開、false = 非公開）
        recruitment_staff: []
      }]
    };
  },
  computed: {},
  mounted: function () {
    var _mounted = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var recruitment, _t;
      return regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (this.$route.params.id) {
              (0, _auth.setRecruitmentID)(this.$route.params.id);
            }
            _context.next = 1;
            return _apolloClient.apolloClient.query({
              query: _recruitmentQuery.GET_RECRUITMENT,
              variables: {
                id: (0, _auth.getRecruitmentID)()
              },
              fetchPolicy: 'no-cache'
            }).catch(function (error) {
              console.error('error' + error);
            });
          case 1:
            recruitment = _context.sent;
            this.$data.form = recruitment.data.recruitment_info;
            _apolloClient.apolloClient.mutate({
              mutation: _recruitmentMutation.CLEAR_RECRUITMENT_STAFF_UPDATE_FLAG,
              variables: {
                id: (0, _auth.getRecruitmentID)()
              },
              fetchPolicy: 'no-cache'
            }).then(function (res) {
              _apolloClient.apolloClient.resetStore();
            }).catch(function (error) {
              console.log(error);
            });
            _context.next = 2;
            return (0, _appUtil.checkReadingFlag)(true);
          case 2:
            _t = _context.sent;
            if (!(_t === true)) {
              _context.next = 3;
              break;
            }
            this.$store.dispatch('app/setKey', (0, _v.default)());
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }(),
  beforeDestroy: function () {
    var _beforeDestroy = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _t2;
      return regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 1;
            return _apolloClient.apolloClient.mutate({
              mutation: _recruitmentMutation.CLEAR_RECRUITMENT_STAFF_UPDATE_FLAG,
              variables: {
                id: (0, _auth.getRecruitmentID)()
              },
              fetchPolicy: 'no-cache'
            }).then(function (res) {
              // apolloClient.resetStore()
            }).catch(function (error) {
              console.log(error);
            });
          case 1:
            _context2.next = 2;
            return (0, _appUtil.checkReadingFlag)(false);
          case 2:
            _t2 = _context2.sent;
            if (!(_t2 === true)) {
              _context2.next = 3;
              break;
            }
            this.$store.dispatch('app/setKey', (0, _v.default)());
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
    function beforeDestroy() {
      return _beforeDestroy.apply(this, arguments);
    }
    return beforeDestroy;
  }(),
  methods: {
    goToDetail: function goToDetail(id) {
      return this.$router.push({
        name: 'StaffDetail',
        params: {
          id: id
        }
      });
    },
    goToMessage: function goToMessage() {
      (0, _auth.setMessageMode)('DETAIL');
      return this.$router.push({
        name: 'RecruitmentMessage',
        params: {
          id: (0, _auth.getRecruitmentID)()
        }
      });
    },
    backToRecruitmentIndex: function backToRecruitmentIndex() {
      return this.$router.push({
        name: 'RecruitmentIndex'
      });
    },
    displayDateTime: function displayDateTime(dateTime, format) {
      return (0, _timeUtil.displayDateTime)(dateTime, format);
    }
  }
};